import { useEffect } from 'react'
import useDashboards from '../../../hooks/useDashboards'
import SimpleLoader from '../../Loader/SimpleLoader'

interface IRootDashboardsProps {
  root_path: string
  onLoaded: (dashboards: any[]) => void
}

export default function RootDashboards({ root_path, onLoaded }: IRootDashboardsProps) {
  const { dashboardsState, loading } = useDashboards(root_path)

  const dashboards = dashboardsState?.dashboards

  useEffect(() => {
    if (!loading && dashboards) {
      onLoaded(dashboards)
    }
  }, [loading, dashboards, onLoaded])

  if (loading) return <SimpleLoader />

  return null
}
